import React, { useMemo } from 'react';
import { orderBy } from 'lodash';
import { IAbandonedBusinessDish } from '../../interfaces/abandoned-business/IAbandonedBusinessDish';
import { IDishSelection } from '../../interfaces/abandoned-business/IAbandonedBusinessSelection';
import DishSelectionCard, { ProductType } from './DishSelectionCard';

type Props = {
  dishes: IAbandonedBusinessDish[];
  selectedDishes: IDishSelection[];
  onToggle: (dishId: string) => void;
  onQuantityChange: (dishId: string, quantity: number) => void;
};

const PRODUCT_TYPE_SORT_ORDER: readonly string[] = [
  ProductType.MAIN,
  ProductType.DESERTS,
  ProductType.DRINKS,
  ProductType.OTHERS,
];

const PRODUCT_TYPE_RANK = new Map(
  PRODUCT_TYPE_SORT_ORDER.map((value, index) => [value, index]),
);

const DishSelectionList: React.FC<Props> = ({
  dishes,
  selectedDishes,
  onToggle,
  onQuantityChange,
}) => {
  const getSelection = (dishId: string) =>
    selectedDishes.find(d => d.dishId === dishId);

  const sortedDishes = useMemo(
    () =>
      orderBy(
        dishes,
        [
          dish =>
            PRODUCT_TYPE_RANK.get(dish.category) ?? Number.MAX_SAFE_INTEGER,
          'name',
        ],
        ['asc', 'asc'],
      ),
    [dishes],
  );

  return (
    <div className='dish-grid'>
      {sortedDishes.map(dish => {
        const selection = getSelection(dish.id);
        return (
          <DishSelectionCard
            key={dish.id}
            dish={dish}
            isSelected={Boolean(selection)}
            quantity={selection?.quantity ?? 1}
            onToggle={() => onToggle(dish.id)}
            onQuantityChange={qty => onQuantityChange(dish.id, qty)}
          />
        );
      })}
    </div>
  );
};

export default DishSelectionList;
